import React, { Component } from "react"
import PropTypes from "prop-types"
import Highcharts from "highcharts"
import Exporting from "highcharts/modules/exporting"
import { translate } from "react-i18next"
import ItemNameCountShape from "../../../state/shapes/ItemNameCountShape"
import { CHARTS } from "../../../constants"

class PieChart extends Component {
  componentDidMount = () => {
    // Get the element into which to insert the chart
    const chartContainer = this.chartContainerRef
    const chartData = this.props.data.map(d => ({
      name: this.props.t(d.itemName),
      y: d.count,
    }))

    const { t, overrideColours, colours, singularTooltipDescriptorKey, pluralTooltipDescriptorKey , titleKey, subtitleKey} = this.props
    Exporting(Highcharts)

    // Create the chart
    this.chart = new Highcharts.Chart({
      chart: {
        renderTo: chartContainer,
        height: CHARTS.standardHeight,
        type: "pie",
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
      },
      lang: {
        contextButtonTitle: t("Common.ChartDownloadOptions"),
      },
      credits: {
        enabled: false,
      },
      colors: overrideColours ? colours : CHARTS.getAreaColours(this.props.data.length),
      title: {
        text: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
        y: -20
      },
      subtitle: {
        text: subtitleKey != null && subtitleKey.length > 0 ? t(subtitleKey) : null,
        y: -5
      },
      tooltip: {        
        formatter: function() {
          // Default to the plural descriptor key
          let descriptorTranslation = pluralTooltipDescriptorKey

          // If there is only one then refer to the singular descriptor key if one has been given.
          if (this.point.y === 1 && singularTooltipDescriptorKey.length > 0) {
            descriptorTranslation = singularTooltipDescriptorKey
          }
          return `<p>${this.key}</p><br/> <b> ${this.point.y + " " + t(descriptorTranslation) + " (" + Highcharts.numberFormat(this.point.percentage, 0)} %) </b>`;
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          dataLabels: {
            enabled: true, // Enabled but hidden on screen, only displayed in print mode
            format: "{point.percentage:.0f}%",
            distance: -30,
            color: "white",
          },
          showInLegend: true,
          animation: CHARTS.animationEnabled,
        },
      },
      series: [
        {
          name: null,
          colorByPoint: true,
          data: chartData,
        },
      ],
      exporting: {
        enabled: CHARTS.exportEnabled,
        buttons: {
          contextButton: {
            menuItems: CHARTS.exportButtons,
          },
        },
        chartOptions: CHARTS.exportChartOptions,
      },
        filename: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
    })
  }

  componentWillUnmount = () => {
    this.chart.destroy()
  }

  render() {
    return (
      <div
        className="chart-container col-md-12"
        ref={(c) => {
          this.chartContainerRef = c
        }}
      />
    )
  }
}

PieChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameCountShape)).isRequired,
  singularTooltipDescriptorKey: PropTypes.string,
  pluralTooltipDescriptorKey: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  overrideColours: PropTypes.bool,
  colours: PropTypes.arrayOf(PropTypes.string),
  titleKey: PropTypes.string,
  subtitleKey: PropTypes.string
}

PieChart.defaultProps = {
  singularTooltipDescriptorKey: ""
}

PieChart.defaultProps = {
  titleKey: '',
  subtitleKey: ''
};

export default translate()(PieChart)



// WEBPACK FOOTER //
// ./src/components/charts/generic/PieChart.jsx